const moderatorTextStyles = {
  fontSize: "13px",
  fontWeight: 400,
  color: "rgba(72, 72, 72, 0.9)",
  mt: { xs: "0px", md: "-40px" },
  mb: { xs: "10px", md: "25px" },
};

const socialIconStyles = {
  objectFit: "contain",
  width: "18px",
  height: "18px",
};

const cardStyles = {
  borderRadius: "12px",
  backgroundColor: "#fff",
  border: "1px solid #eaeaea",
  boxShadow: "none",
  padding: "24px",
  marginBottom: "24px",
  width: "100%",
};

const subheadingBoxStyles = {
  pt: "32px",
  pb: "32px",
};

const descriptionTextStyles = {
  fontSize: "15px",
  fontWeight: 400,
};

const newPlatformContainerStyles = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
  alignItems: {
    xs: "stretch",
    sm: "flex-end",
  },
  justifyContent: "space-between",
  width: "100%",
  gap: "16px",
};

const errorTextStyles = {
  mt: "4px",
  fontSize: "15px",
  fontWeight: 400,
  color: "#D8000C",
};

const platformLabelStyles = {
  fontSize: "15px",
  fontWeight: 500,
};

const addPlatformButtonStyles = {
  whiteSpace: "nowrap",
  backgroundColor: "rgba(242, 243, 251, 1)",
  border: "1px solid rgba(242, 243, 251, 1)",
  color: "rgba(37, 124, 109, 1)",
  borderRadius: "8px",
  fontSize: "15px",
  fontWeight: 500,
  width: "128px",
  height: "39px",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(242, 243, 251, 0.9)",
  },
  "&.Mui-disabled": { opacity: 0.8 },
};

const existingPlatformsContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  mb: "24px",
};

const existingPlatformBoxStyles = {
  display: "flex",
  alignItems: {
    xs: "flex-start",
    sm: "center",
  },
  flexDirection: {
    xs: "column",
    sm: "row",
  },
  width: "100%",
  gap: { xs: "6px", sm: "28px" },
  opacity: "0.7",
};

const platformIconBoxStyles = {
  display: "flex",
  alignItems: "center",
  px: { xs: "0px", sm: "12px" },
  gap: "6px",
  width: "127px",
};

const platformTextStyles = {
  fontSize: "15px",
  fontWeight: 400,
};

const linkBoxStyles = {
  display: "flex",
  alignItems: "center",
  gap: { xs: "16px", sm: "28px" },
};

const linkTextStyles = {
  fontSize: "15px",
  fontWeight: 400,
  maxWidth: { xs: "100%", sm: "400px" },
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  whiteSpace: { xs: "normal", sm: "nowrap" },
  wordBreak: "break-word",
  WebkitLineClamp: { xs: 2, sm: "unset" },
};

const saveChangesButtonStyles = {
  fontSize: "15px",
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "rgba(37, 124, 109, 1)",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(37, 124, 109, 0.9)",
    boxShadow: "none",
  },
};

const saveButtonWrapperStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  mt: "36px",
  // Clearance for the floating Keilot AI launcher (fixed to the same bottom
  // corner, 56px + 24px offset), so it never sits on top of "Save".
  mb: { xs: "80px", md: "96px" },
};

const inputGridStyles = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "1fr 1fr",
  },
  gap: "24px",
  width: "100%",
};

const tagsContainerStyles = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 1,
  mt: "12px",
};

const tagsInputBoxStyles = {
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  minHeight: "42px",
  px: "12px",
  py: "8px",
  border: "1px solid",
  borderRadius: "8px",
  borderColor: "rgba(230, 228, 235, 1)",
  "&:hover": {
    borderColor: "rgba(36, 139, 112, 1)",
  },
  "&:focus-within": {
    borderColor: "rgba(36, 139, 112, 1)",
    boxShadow: "0 0 0 1px rgba(36, 139, 112, 1)",
  },
};

const chipStyles = {
  borderRadius: "6px",
  backgroundColor: "rgba(47, 43, 61, 0.08)",
  color: "rgba(47, 43, 61, 0.9)",
  height: "24px",
  "& .MuiChip-label": {
    px: "8px",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "20px",
  },
  "& .MuiChip-deleteIcon": {
    color: "rgba(62, 63, 76, 0.7)",
    fontSize: "16px",
    "&:hover": {
      color: "rgba(62, 63, 76, 0.7)",
    },
  },
};

const tagsDropdownContainerStyles = {
  position: "relative",
  zIndex: 1,
};

const tagsDropdownListStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  maxHeight: "200px",
  overflowY: "auto",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  border: "1px solid #e0e0e0",
  zIndex: 1300,
};

const tagsDropdownItemStyles = {
  p: 1.5,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
};

const uploadTOSCardTextStyles = {
  fontSize: "18px",
  fontWeight: 500,
  color: "#3E3F4C",
  display: "flex",
  alignItems: "center",
};

const uploadTOSDescriptionStyles = {
  paddingTop: "32px",
  paddingBottom: "24px",
};

const muiStyles = {
  moderatorTextStyles,
  socialIconStyles,
  cardStyles,
  subheadingBoxStyles,
  descriptionTextStyles,
  newPlatformContainerStyles,
  platformLabelStyles,
  addPlatformButtonStyles,
  existingPlatformsContainerStyles,
  existingPlatformBoxStyles,
  platformIconBoxStyles,
  platformTextStyles,
  linkBoxStyles,
  linkTextStyles,
  saveButtonWrapperStyles,
  saveChangesButtonStyles,
  inputGridStyles,
  tagsContainerStyles,
  tagsInputBoxStyles,
  chipStyles,
  tagsDropdownContainerStyles,
  tagsDropdownListStyles,
  tagsDropdownItemStyles,
  uploadTOSCardTextStyles,
  uploadTOSDescriptionStyles,
  errorTextStyles,
};

export default muiStyles;
